import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import { Card, Row, Col } from 'antd';
import Item from './Item';
import { usePassport, usePassportCategory } from './data';
import PieComponent from './Charts/PieComponent';
import { PIE_CHART, useChartData } from './Charts/config';

const PassportStatistic = () => {
  const { loading, passport } = usePassport();
  const { passportCategory } = usePassportCategory();

  const pieData = useChartData({ data: passportCategory, type: PIE_CHART, label: '' });

  return (
    <Auxiliary>
      <Row>
        <Col span={24}>
          <Card className="gx-card gx-p-15 gx-text-center" title="Total User">
            <Row>
              <Col span={12}>
                <Item label={`Total User`} value={passport.total} loading={loading} />
              </Col>
              <Col span={12}>
                <Item label={`Request User`} value={passport.request} loading={loading} />
              </Col>
            </Row>
          </Card>
        </Col>
        {/* <Col span={12}>
          <PieComponent data={pieData}/>
        </Col> */}
      </Row>
    </Auxiliary>
  );
}

export default PassportStatistic;